import apiClient from '../../../services/api';

const STORE_WEBSITES_BASE = '/api/store-websites';
const CMS_PAGES_BASE = '/api/cms-pages';

// Store Website API
export const storeWebsiteApi = {
  // Get website settings for a location
  getByLocation: async (locationId) => {
    const response = await apiClient.get(`${STORE_WEBSITES_BASE}/location/${locationId}`);
    return response.data;
  },

  // Create website for a location
  create: async (data) => {
    const response = await apiClient.post(STORE_WEBSITES_BASE, data);
    return response.data;
  },

  // Update website settings
  update: async (websiteId, data) => {
    const response = await apiClient.patch(`${STORE_WEBSITES_BASE}/${websiteId}`, data);
    return response.data;
  },

  // Delete website
  delete: async (websiteId) => {
    const response = await apiClient.delete(`${STORE_WEBSITES_BASE}/${websiteId}`);
    return response.data;
  },

  // Verify custom domain
  verifyDomain: async (websiteId) => {
    const response = await apiClient.post(`${STORE_WEBSITES_BASE}/${websiteId}/verify-domain`);
    return response.data;
  },

  // Get domain verification status
  getDomainStatus: async (websiteId) => {
    const response = await apiClient.get(`${STORE_WEBSITES_BASE}/${websiteId}/domain-status`);
    return response.data;
  },

  // Generate slug from store name
  generateSlug: (storeName) => {
    return storeName
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  },

  // Get the public website URL
  getPublicUrl: (website, platformDomain) => {
    if (website.custom_domain && website.custom_domain_verified) {
      return `https://${website.custom_domain}`;
    }
    return `https://${website.slug || website.subdomain_slug}.${platformDomain}`;
  },
};

// CMS Pages API
export const cmsPagesApi = {
  // Get all pages for a website
  getByWebsite: async (websiteId) => {
    const response = await apiClient.get(`${CMS_PAGES_BASE}/website/${websiteId}`);
    return response.data;
  },

  // Get a single page
  getById: async (pageId) => {
    const response = await apiClient.get(`${CMS_PAGES_BASE}/${pageId}`);
    return response.data;
  },

  // Create a new page
  create: async (data) => {
    const response = await apiClient.post(CMS_PAGES_BASE, data);
    return response.data;
  },

  // Update a page
  update: async (pageId, data) => {
    const response = await apiClient.patch(`${CMS_PAGES_BASE}/${pageId}`, data);
    return response.data;
  },

  // Delete a page
  delete: async (pageId) => {
    const response = await apiClient.delete(`${CMS_PAGES_BASE}/${pageId}`);
    return response.data;
  },

  // Publish a page
  publish: async (pageId) => {
    const response = await apiClient.post(`${CMS_PAGES_BASE}/${pageId}/publish`);
    return response.data;
  },

  // Unpublish a page
  unpublish: async (pageId) => {
    const response = await apiClient.post(`${CMS_PAGES_BASE}/${pageId}/unpublish`);
    return response.data;
  },

  // Default page types
  PAGE_TYPES: {
    ABOUT: 'about',
    CONTACT: 'contact',
    HOURS: 'hours',
    CUSTOM: 'custom',
  },

  // Get default pages template
  getDefaultPages: (websiteId) => [
    {
      website_id: websiteId,
      page_type: 'about',
      slug: 'about',
      title: 'About Us',
      content: '',
      is_published: false,
    },
    {
      website_id: websiteId,
      page_type: 'contact',
      slug: 'contact',
      title: 'Contact Us',
      content: '',
      is_published: false,
    },
    {
      website_id: websiteId,
      page_type: 'hours',
      slug: 'hours',
      title: 'Store Hours',
      content: '',
      store_hours: {
        monday: { open: '09:00', close: '21:00', closed: false },
        tuesday: { open: '09:00', close: '21:00', closed: false },
        wednesday: { open: '09:00', close: '21:00', closed: false },
        thursday: { open: '09:00', close: '21:00', closed: false },
        friday: { open: '09:00', close: '21:00', closed: false },
        saturday: { open: '09:00', close: '21:00', closed: false },
        sunday: { open: '10:00', close: '18:00', closed: false },
      },
      is_published: false,
    },
  ],
};

const websiteApis = { storeWebsiteApi, cmsPagesApi };
export default websiteApis;
